// eslint-disable-next-line jira/import-whitelist
import getMeta from '@atlassian/jira-get-meta';

export const useOrgId = (): { data: string | undefined } => {
	const orgId = getMeta('ajs-org-id');
	return { data: orgId || undefined };
};
